<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/pinia/auth'
import { useStyleStore } from '@/pinia/style'
import { useRoute } from 'vue-router'

const authStore = useAuthStore()
const styleStore = useStyleStore()
const route = useRoute()

function closeForAWeek() {
  authStore.lastClosedMaintenancePopUp = new Date()
}

const isPopUp = computed(() => {
  const lastClosedMaintenancePopUp = new Date(authStore.lastClosedMaintenancePopUp)
  // Internally calls getTime
  if (isNaN(lastClosedMaintenancePopUp)) {
    return true
  }
  const aWeek = 7 * 24 * 60 * 60 * 1000
  const current = new Date().getTime()
  return lastClosedMaintenancePopUp.getTime() + aWeek < current
})
</script>

<template>
  <div
    v-if="!route.name?.includes('Design Online') && isPopUp && styleStore.fabricator?.systemMessage"
    class="fixed top-0 !z-50 w-full p-3 pointer-events-none"
  >
    <div
      class="relative flex gap-5 w-full mx-auto max-w-[1000px] rounded border border-amber-300 bg-amber-100 shadow-xl p-5 pointer-events-auto"
    >
      <div class="flex gap-4 w-full">
        <div class="hidden xs:flex flex-col justify-start pt-1 text-amber-800">
          <i class="text-xl fal fa-warning"></i>
        </div>
        <div class="grow">
          <p class="font-medium text-amber-950">Important Notice</p>
          <p class="text-sm text-amber-900">{{ styleStore.fabricator.systemMessage }}</p>
        </div>
        <i
          class="text-amber-900 ml-auto text-2xl cursor-pointer block fa-light fa-circle-xmark"
          @click="closeForAWeek"
        />
      </div>
    </div>
  </div>
</template>
